<template>
  <section class="app-main">
    <router-view :key="key"></router-view>
  </section>
</template>
<script>
  export default {
    name: 'AppMin',
    computed: {
      key () {
        return this.$route.name !== undefined ? this.$route.name + new Date() : this.$route + new Date()
      }
    }
  }
</script>
<style lang="scss" scoped>
.app-main{
  background:#fff;
  margin:0;
  padding:15px 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/frame/AppMain.vue